import { render, staticRenderFns } from "./ParseContent.vue?vue&type=template&id=50d9a530&scoped=true"
import script from "./ParseContent.vue?vue&type=script&lang=js"
export * from "./ParseContent.vue?vue&type=script&lang=js"
import style0 from "./ParseContent.vue?vue&type=style&index=0&id=50d9a530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d9a530",
  null
  
)

export default component.exports